import { useState, useEffect } from "react";
import { createAppRoutes } from "./routes/AppRouter";
import { RouterProvider } from "react-router";
import { ThemeProvider, CssBaseline, GlobalStyles } from "@mui/material";
import { MediaProvider } from "./context/MediaContext";
import { darkTheme, lightTheme } from "./context/theme";
import { createBrowserRouter } from "react-router";

const App: React.FC = () => {
  const [isDark, setIsDark] = useState<boolean>(() => {
    return localStorage.getItem("darkTheme") === "true";
  });
  const AppRouter = createBrowserRouter(createAppRoutes(isDark, setIsDark));

  useEffect(() => {
    localStorage.setItem("darkTheme", String(isDark));
  }, [isDark]);

  return (
    <ThemeProvider theme={isDark ? darkTheme : lightTheme}>
      <CssBaseline />
      <GlobalStyles
        styles={(theme) => ({
          "html, body, #root": {
            minHeight: "100dvh",
            margin: 0,
            padding: 0,
            overflow: "hidden",
            colorScheme: theme.palette.mode,
            backgroundColor: theme.palette.background.default,
          },
          body: {
            textRendering: "optimizeLegibility",
          },
        })}
      />

      <MediaProvider>
        <RouterProvider router={AppRouter} />
      </MediaProvider>
    </ThemeProvider>
  );
};

export default App;
